import { FC, ReactNode } from 'react';

interface ConditionalRenderProps {
  conditions: { when: boolean; render: ReactNode }[];
  otherwise?: ReactNode;
}

export const ConditionalRender: FC<ConditionalRenderProps> = ({
  conditions,
  otherwise = null,
}) => {
  const match = conditions.find((condition) => condition.when);
  return <>{match ? match.render : otherwise}</>;
};
